/*
 * Copyright 1999-2024 Jagex Ltd.
 */
import { Logo, LOGOS } from '@jagex/design_runescape';
import React, { FunctionComponent } from 'react';
import { LogoWrapper, LogoWrapperProps } from './styled';

type Props = Omit<LogoWrapperProps, 'ref'>;

export const LogoContainer: FunctionComponent<Props> = props => (
  <LogoWrapper {...props}>
    <Logo logo={LOGOS.OLDSCHOOL} />
    <Logo logo={LOGOS.RUNESCAPE} />
  </LogoWrapper>
);
